export const PLAN_PAYMENT_METHODS = [
  {
    key: "credit_card",
    value: "credit_card",
    text: "Cartão de Crédito",
  },
  {
    key: "boleto",
    value: "boleto",
    text: "Boleto",
  },
];

export const COURSE_EXTENSION_ID = 7068; //ID Curso do Produto de Extensão de Curso
export const FORMATION_EXTENSION_ID = 7069; //ID Curso do Produto de Extensão de Formação
export const MBA_EXTENSION_ID = 7070; //ID Curso do Produto de Extensão de MBA
export const VOITTO_PRO_EXTENSION_COURSE_ID = 7071; //ID Curso do Produto de Extensão de Voitto PRO

export const creditCardInstallments = Array(18)
  .fill(null)
  .map((_, index) => ({
    label: `${index + 1}x no cartão`,
    value: index + 1,
  }));